import React from 'react';
import { DashboardLayout } from 'src/skins/venus/components/layouts';
import { BuyAirtimeForm } from 'src/skins/venus/forms';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { VenusModal } from 'src/skins/venus/components/common';

const pageTitle = 'Buy Airtime';

const Wrapper = styled.div`
  section {
    margin: 1rem 0;
  }
`;

const BuyAirtime = () => {
  const history = useHistory();
  return (
    <DashboardLayout>
      <VenusModal isOpen={true} closeModal={() => history.goBack()} fullheight={true} backgroundPage="bills">
        <Wrapper>
          <h2>{pageTitle}</h2>

          <section>
            <BuyAirtimeForm />
          </section>
        </Wrapper>
      </VenusModal>
    </DashboardLayout>
  );
};

export default BuyAirtime;
